import { MgSupplierDTO } from '../../dto/mgItem/SupplierDTO';

interface Props {
  id: number;
  mgSupplierId: number;
  name: string;
  isManufacturer: boolean;
  gln: number;
  orgNumber: number;
}

export class MgSupplier {
  id: number;
  mgSupplierId: number;
  name: string;
  isManufacturer: boolean;
  gln: number;
  orgNumber: number;

  constructor({ id, mgSupplierId, name, isManufacturer, gln, orgNumber }: Props) {
    this.id = id;
    this.mgSupplierId = mgSupplierId;
    this.name = name;
    this.isManufacturer = isManufacturer;
    this.gln = gln;
    this.orgNumber = orgNumber;
  }
  static fromDto = (dto: MgSupplierDTO): MgSupplier =>
    new MgSupplier({
      id: dto.id,
      mgSupplierId: dto.mgSupplierId,
      name: dto.name,
      isManufacturer: dto.isManufacturer,
      gln: dto.gln,
      orgNumber: dto.orgNumber,
    });
}
